import script from "./CasinoLivePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CasinoLivePage.vue?vue&type=script&setup=true&lang=ts"

import "./CasinoLivePage.vue?vue&type=style&index=0&id=12ec83ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ec83ba"]])

export default __exports__